import React, { FC, useCallback } from 'react';

import Modal from 'molecules/Modal';
import { ModalContent } from 'molecules/Modal/Modal.styles';
import ProjectErrorTable from '.';

import { Stack } from '@mui/material';
import { contractTypeMap } from 'utils/constants/common';
import {
  StyledReportDetails,
  StyledReportDetailsText,
} from './ProjectErrorTable.styles';
import { IZohoProject } from 'pages/CompanyPage/types';

export const ProjectErrorModal: FC<{
  project: IZohoProject;
  onClose: () => void;
}> = ({ project, onClose }) => {
  const handleModalClose = useCallback(() => {
    onClose();
    document.body.setAttribute('id', '');
  }, []);

  if (!project) return <span />;

  return (
    <Modal
      open
      maxWidth="lg"
      title="Incorrect billing data details"
      subtitle="This window shows project field errors from Zoho Projects that may block auto-invoicing, with detailed explanations for each issue."
      onClose={handleModalClose}
      sx={{ zIndex: 33333 }}
    >
      <ModalContent
        sx={{
          paddingBottom: '16px !important',
          maxHeight: '400px',
          overflow: 'hidden',
        }}
      >
        <StyledReportDetails>
          <Stack direction="row">
            <StyledReportDetailsText $bold>
              Project name:
            </StyledReportDetailsText>
            <StyledReportDetailsText>{project?.name}</StyledReportDetailsText>
          </Stack>
          <Stack direction="row">
            <StyledReportDetailsText $bold>
              Contract type:
            </StyledReportDetailsText>
            <StyledReportDetailsText>
              {contractTypeMap[project?.contract_type]}
            </StyledReportDetailsText>
          </Stack>
        </StyledReportDetails>
        {project ? <ProjectErrorTable project={project} /> : '...'}
      </ModalContent>
    </Modal>
  );
};
